import type { ComponentType } from "react";
import {
  IconArrowRotateAnticlockwiseOutline18,
  IconArrowRotateClockwiseOutline18,
  IconCodeBranchOutline18,
  IconFilterOutline18,
} from "nucleo-ui-outline-18";
import type { ActionTriggerDefinition } from "@/hooks/useActionTriggerDefinitions";
import { capitalizeWords } from "@/lib/utils";

/**
 * Canonical set of logic (control-flow) action types.
 * Used to classify nodes as "logic" vs "action" in contexts without
 * access to the backend definitions API (minimap, public canvas, etc.).
 */
export const LOGIC_TYPES = new Set([
  "if",
  "for-each",
  "and",
  "or",
  "not",
  "filter",
  "wait",
  "delay",
  "pluck",
  "format",
  "log",
  "storage",
]);

export const LOGIC_DEFINITIONS: ActionTriggerDefinition[] = Array.from(LOGIC_TYPES).map(type => ({
  type,
  name: capitalizeWords(type.replace(/-/g, " ")),
  description: "",
  category: "logic",
  payloadSchema: {
    type: "object" as const,
    properties: {},
    additionalProperties: true,
  },
}));

/** Returns the Lucide icon component for a logic node type. */
export function getLogicIcon(logicType: string): ComponentType<{
  className?: string;
}> {
  switch (logicType) {
    case "if":
      return IconCodeBranchOutline18;
    case "for-each":
      return IconArrowRotateClockwiseOutline18;
    case "and":
    case "or":
      return IconFilterOutline18;
    case "not":
      return IconArrowRotateAnticlockwiseOutline18;
    default:
      return IconCodeBranchOutline18;
  }
}
